import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchInstrumentStatusesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchInstrumentStatuses`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getInstrumentStatuses();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch instrument statuses. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
